document.addEventListener("DOMContentLoaded", function () {

    const booster = document.querySelector(".gf-conversion-booster");

    if (!booster) return;

    const qtyInput = document.querySelector(".quantity__input");

    if (!qtyInput) return;

    const price = parseFloat(booster.dataset.price);

    const qtyText = document.getElementById("gf-selected-qty");
    const discountText = document.getElementById("gf-discount");
    const savingText = document.getElementById("gf-savings");
    const totalText = document.getElementById("gf-total");

    const nextDiscount = document.getElementById("gf-next-discount");

    const progressFill = document.querySelector(".gf-progress-fill");

    const rows = document.querySelectorAll(".gf-discount-row");



    /* =======================
       TIMER
    ======================= */

    let endTime = localStorage.getItem("gf_timer");

    if (!endTime) {

        endTime = Date.now() + (24 * 60 * 60 * 1000);

        localStorage.setItem("gf_timer", endTime);

    }

    function updateTimer(){

        let distance = endTime - Date.now();

        if(distance <=0){

            endTime = Date.now() + (24*60*60*1000);

            localStorage.setItem("gf_timer", endTime);

            distance = endTime - Date.now();

        }

        const hours = Math.floor(distance/(1000*60*60));

        const minutes = Math.floor((distance%(1000*60*60))/(1000*60));

        const seconds = Math.floor((distance%(1000*60))/1000);

        document.getElementById("gf-hours").innerHTML = String(hours).padStart(2,'0');

        document.getElementById("gf-minutes").innerHTML = String(minutes).padStart(2,'0');

        document.getElementById("gf-seconds").innerHTML = String(seconds).padStart(2,'0');

    }

    setInterval(updateTimer,1000);

    updateTimer();



    /* =======================
       CALCULATOR
    ======================= */

   function updateCalculator(){

    let qty = parseInt(qtyInput.value);

    if(isNaN(qty)) qty = 1;

    qtyText.innerHTML = qty;

    let discount = 0;

    if(qty >= 2 && qty <=10){

        discount = 10;

    }

    else if(qty >=11 && qty <=25){

        discount = 20;

    }

    else if(qty >=26){

        discount = 30;

    }

    discountText.innerHTML = discount + "%";



    const subtotal = price * qty;

    const saving = subtotal * discount /100;

    const finalTotal = subtotal - saving;



    savingText.innerHTML =
        "$" + saving.toFixed(2);

    totalText.innerHTML =
        "$" + finalTotal.toFixed(2);



    rows.forEach(row=>{

        row.style.background="";

        row.style.border="1px solid rgba(255,255,255,.08)";



        const min=parseInt(row.dataset.min);

        const max=parseInt(row.dataset.max);



        if(qty>=min && qty<=max){

            row.style.background="linear-gradient(90deg,#3b2a00,#c79b18)";

            row.style.border="1px solid #ffd45f";

        }

    });
let remain = 0;

if(qty < 2){

    remain = 2 - qty;

    nextDiscount.innerHTML =
    "🔥 Add <b>"+remain+"</b> more piece to unlock <b>10% OFF</b>";

    progressFill.style.width = (qty/2)*100+"%";

}

else if(qty<=10){

    remain = 11 - qty;

    nextDiscount.innerHTML =
    "🔥 Add <b>"+remain+"</b> more pieces to unlock <b>20% OFF</b>";

    progressFill.style.width=((qty-2)/9)*100+"%";

}

else if(qty<=25){

    remain = 26 - qty;

    nextDiscount.innerHTML =
    "🔥 Add <b>"+remain+"</b> more pieces to unlock <b>30% OFF</b>";

    progressFill.style.width=((qty-11)/15)*100+"%";

}

else{

    nextDiscount.innerHTML =
    "🎉 Congratulations! You unlocked our highest bulk discount.";

    progressFill.style.width="100%";

}
}

    qtyInput.addEventListener("input",updateCalculator);

    qtyInput.addEventListener("change",updateCalculator);

    updateCalculator();

});